@use '../styles/tokens' as *;

.page {
  display: flex;
  flex-direction: column;
  height: 100dvh;
  overflow: hidden;
  background: $blue-gray-9;
}

.gallery {
  flex: 1;
  min-height: 0;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(3, 1fr);
  gap: 20px;

  @include lg {
    width: 50%;
  }
}

.gallery__item {
  overflow: hidden;
  border-radius: 14px;
  background: #e3e6ea;
}

.gallery__item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* column 1 -> 1 : 2   |   column 2 -> 2 : 1 */
.gallery__item:nth-child(1) {
  grid-column: 1;
  grid-row: 1 / 2;
  border-radius: 0 0 14px 0;
}
.gallery__item:nth-child(2) {
  grid-column: 1;
  grid-row: 2 / 4;
  border-radius: 0 14px 0 0;
}
.gallery__item:nth-child(2) img {
  object-position: 68% center;
}
.gallery__item:nth-child(3) {
  grid-column: 2;
  grid-row: 1 / 3;
  border-radius: 0 0 14px 14px;
}
.gallery__item:nth-child(3) img {
  object-position: 60% center;
}
.gallery__item:nth-child(4) {
  grid-column: 2;
  grid-row: 3 / 4;
  border-radius: 14px 14px 0 0;
}

// ----- Card -----
.card {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: min(560px, calc(100% - 40px));
  max-height: calc(100dvh - 40px);
  overflow-y: auto;
  box-shadow: 0 30px 80px rgba(20, 24, 40, 0.14);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  padding: 40px;
  border-radius: $radius-box;
  background: $white;
  text-align: center;

  @include lg {
    padding: 80px;
    width: 690px;
  }
}

.intro {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
}

.heading {
  display: flex;
  flex-direction: column;
}

.eyebrow {
  @include text-13;
  font-weight: 500;
  color: $blue-5;
  text-transform: uppercase;
}

.title {
  @include text-heading-2;
  color: $blue-gray-2;
  margin: 0;
}

.titleError {
  color: $error;
}

.subtitle {
  @include text-13;
  color: $base-3;

  @include lg {
    @include text-body-2;
  }
}

.actions {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 15px;
}

.cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 46px;
  padding: 0 40px;
  border-radius: 999px;
  background: $utility-blue;
  @include text-13;
  font-weight: 700;
  color: $white;
  text-decoration: none;
  white-space: nowrap;
}

.ctaOutline {
  background: none;
  border: 2px solid $black;
  color: $black;
}
